import { ChangeEvent, useEffect, useState } from "react";
import { Switch } from "@mui/material";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMe } from "../../auth/MeContext";
import { PERM } from "../../auth/permissions";
import api from "../../hooks/api";
import { pathAPI } from "../../utils/pathApi";

interface CategoryActiveToggleProps {
  categoryId: number;
  active: boolean;
  onUpdated: (id: number, active: boolean) => void;
}

const CategoryActiveToggle = ({
  categoryId,
  active,
  onUpdated,
}: CategoryActiveToggleProps) => {
  const { t } = useTranslation();
  const { can } = useMe();
  const [checked, setChecked] = useState(active);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setChecked(active);
  }, [active]);

  const handleChange = async (_event: ChangeEvent<HTMLInputElement>, next: boolean) => {
    const previous = checked;
    setChecked(next);
    setSaving(true);
    try {
      await api.PUT(
        `${pathAPI.categoryDetail}/${categoryId}/active`,
        { active: next },
        {},
        true
      );
      onUpdated(categoryId, next);
    } catch {
      setChecked(previous);
      toast.error(t("category.messages.error"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Switch
      size="small"
      checked={checked}
      disabled={saving || !can(PERM.CATEGORY_UPDATE)}
      onChange={handleChange}
      sx={{
        "& .MuiSwitch-switchBase.Mui-checked": { color: "#ba2156" },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
          backgroundColor: "#ba2156",
        },
      }}
    />
  );
};

export default CategoryActiveToggle;
